<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="open=false"><v-icon large>fal fa-times</v-icon></button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding extra-padding">
				<div style="color: #666; font-size: 0.9em;">
					<div v-if="userInAddon(this.user.pk)">
						<p>You're already signed up for this addon!</p>
					</div>
					<div v-else>
						<h2 class="mb-2">{{event.addons[0].title}}</h2>
						<p v-if="addonStarted" class="mb-2" style="font-size: 0.9em; color: #AAA;">The addon has already started, if you would still like to participate make sure you consult your host before signing up.</p>
						<p>{{event.addons[0].description}}</p>
						<div style="display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center;">
							<div :class="{'full-width': isMobile}">
								<h4 class="mb-0">Start time: {{event.addons[0].start_time}}</h4>
								<h4 class="mb-0">End time: {{event.addons[0].end_time}}</h4>
							</div>
							<v-btn v-if="!isMobile" class="ma-0 btn-orange addon-button" @click="purchaseAddon">Purchase ${{event.addons[0].price}} {{event.addons[0].title}}</v-btn>
							<v-btn v-else block class="ma-0 mt-3 mb-3 btn-orange addon-button" @click="purchaseAddon">Purchase ${{event.addons[0].price}} {{event.addons[0].title}}</v-btn>
						</div>
					</div>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
	name: 'AddonUpsellModal',
	methods: {
		...mapActions(['setModalOpen', 'openPurchaseAddonModal']),
		purchaseAddon () {
			this.openPurchaseAddonModal()
		},
		userInAddon(pk) {
			if (this.event.addons.length > 0) {
				if (this.event.addons[0].attendees) {
					if (this.event.addons[0].attendees.includes(pk)) {
						return true
					}
				}
			}
			return false
		},
	},
	computed: {
		...mapGetters(['getModalProp', 'user', 'getAllEvents']),
		open: {
			get() {
				return this.getModalProp('addonUpsellModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'addonUpsellModal', value: val })
			}
		},
		event() {
			return this.getAllEvents.find(
				obj => String(obj.slug) === String(this.$route.params.slug)
			)
		},
		addonStarted () {
			if (this.event.addons.length > 0) {
				let startTimeString = this.event.addons[0].start_time.substring(0, this.event.addons[0].start_time.length - 3)
				let startTimeA = this.event.addons[0].start_time.substring(this.event.addons[0].start_time.length - 2, this.event.addons[0].start_time.length)
				let startTimeHours = parseInt(startTimeString.split(':')[0])
				let startTimeMinutes = parseInt(startTimeString.split(':')[1])
				if (startTimeA === 'am') {
					if (startTimeHours === 12) {
						startTimeHours = 0
					}
				} else if (startTimeA = 'pm') {
					if (startTimeHours !== 12) {
						startTimeHours += 12
					}
				}

				let addonStart = moment()
				addonStart.set('hours', startTimeHours)
				addonStart.set('minutes', startTimeMinutes)
				addonStart.set('seconds', 0)

				return (addonStart < moment())
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>

<style lang='scss'>
.addon-button {
	width: 185px!important;
	min-width: 185px!important;
	height: 60px!important;
	min-height: 60px!important;
	border-radius: 10px;
	font-size: 1.25em;
	font-weight: bold;
}

.full-width {
	width: 100%;
}

@media screen and (max-width: 600px) {
	.extra-padding {
		padding: 30px;
	}
}
</style>